import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Event} from '../../models/eventRequest';

@Component({
    selector: 'app-driving-event-list',
    templateUrl: './driving-event-list.component.html',
    styleUrls: ['./driving-event-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrivingEventListComponent implements OnInit {

  toDay: Date = new Date();

  @Input()
  iShowDrivingEvents: boolean = false;

  @Input()
  iPageDrivingEvent: any;

  @Input()
  iDrivingEvents: Event[] = [];

  @Input()
  iShowStudent: boolean = false;

  @Input()
  iNavMobile: boolean = false;

  @Output()
  iPageNumber: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
  }

  getDate(stringDate: string) : Date {
    return new Date(stringDate)
  }

  getBoxTypeLabel(boxType: string): string {
    return boxType === 'AUTOMATIQUE' ? 'Automatique' : 'Manuelle';
  }

  isConsumed(start: string): boolean {
    return this.getDate(start).getTime() < this.toDay.getTime();
  }

  onChangeConsumptionPage($event: number) {
    this.iPageNumber.emit($event);
  }
}
